import http from "@/utils/httpRequest";
// 获取消息中心列表
export const apiBasicMsglogList = (params ) => {
    return http.post("/basic/msg/logList", { ...params }, { baseURL:baseSSOURL });
}
export const apiIgnoreMsg = (params) => {
    return http.post(`/basic/msg/ignoreMsg/${params.id}`, {},{ baseURL:baseSSOURL });
}
// 便捷入口获取列表地址
export const apiShortcutList = (params) => {
    return http.post(`/shortcut/list`,{...params});
} 
// 获取便捷入口源数据
export const loadSourceApps = (params) => {
    return http.post("/shortcut/loadSourceApps", { ...params });
};
// 便捷入口弹框添加数据
export const shortCutBatchInsert = (params) => {
    return http.post(`/shortcut/batchInsert`, params);
};
// 便捷入口删除数据
export const shortCutDelete = (params) => {
    return http.post(`/shortcut/delete`, params);
};
// 获取待办列表
export const apiUserTaskListBox = (params) => {
    return http.post(`/userTask/listBox`, {...params})
}
// 获取业务节点数据
export const apiUserTaskQueryFlownodeList = (params) => {
    return http.get(`/userTask/queryFlownodeList?busType=${params.busType}`)
}
// 获取首页待办
export const apiUserTaskList = (params) => {
    return http.post(`/userTask/list`, {...params})
}
// 获取待办总数
export const apiUserTaskTotal = (params) => {
    return http.post(`/userTask/total`,{...params})
}
// 获取开评标数量
export const apiFieldApplyBaseFieldapplybaseQueryBidTodayCount = (params) => {
    return http.get(`/fieldApplyBase/fieldapplybase/queryBidTodayCount?day=${params}`)
}
// 获取今日开标列表
export const apiFieldApplyBaseFieldapplybaseQueryBidTodayList = (params) => {
    return http.get(`/fieldApplyBase/fieldapplybase/queryBidTodayList?day=${params.date}&tradeId=${params.tradeId}`)
}
// 获取日期范围内哪天有开评标的
export const apiFieldApplyBaseFieldapplybaseQueryCalendar = (params) => {
    return http.get(`/fieldApplyBase/fieldapplybase/queryCalendar?startTime=${params.startTime}&endTime=${params.endTime}`)
}
// 获取市级接口
export const apiUserTaskQueryRegion = (params) => {
    return http.get(`/userTask/queryRegion?regionCode=${params}`)
}

// 日程管理列表
export const apiwbschedulemanagementlist = (params) => {
    return http.post(`/jzschedulemanagement/list`,
        { ...params },
    );
}
// 日程管理新增
export const apiwbschedulemanagementsave = (params) => {
    return http.post(`/jzschedulemanagement/save`,
        { ...params },
    );
};
// 日程管理查看
export const apiwbschedulemanagementget = (params) => {
    return http.get(`/jzschedulemanagement/get?id=${params}`,);
}
// 日程管理删除
export const apiwbschedulemanagementdelete = (params) => {
    return http.get(`/jzschedulemanagement/delete/${params}`,);
}
// 日程管理完成
export const apiwbschedulemanagementupdateCompleteStatus = (params) => {
    return http.get(`/jzschedulemanagement/updateCompleteStatus/${params}`,);
}

// 统计-项目见证受理
export const apiHomeStatisticsQueryAcceptNum = (params) => {
    return http.get(`/homeStatistics/queryAcceptNum?type=${params}`)
}
// 统计-场地预约
export const apiHomeStatisticsQuerySiteNum = (params) => {
    return http.get(`/homeStatistics/querySiteNum?type=${params}`)
}
// 统计-专家抽取
export const apiHomeStatisticsQueryExperttNum = (params) => {
    return http.get(`/homeStatistics/queryExpertNum?type=${params}`)
}
// 统计-远程异地项目
export const apiHomeStatisticsQueryAllopatricNum = (params) => {
    return http.get(`/homeStatistics/queryAllopatricNum?type=${params}`)
}
